<script>
  import { setContext, onMount } from "svelte";
  
  import formatDateTime from "common/utils/formatDateTime"
  import Log from "./Log";

  export let channelId;

  let alerts = [];

  function handleLogMessage(message) {
    alerts = alerts.concat([message]);
  }

  const format = formatDateTime('HH:mm:SS');

  onMount(() => {
    const subscription = App.cable.subscriptions.create(
      {
        channel: "StreamEventChannel",
        sockets_token: `channel:${channelId}`,
      },
      {
        received: function (data) {
          switch (data.type) {
            case "alert":
              return handleLogMessage(data);
          }
        },
        render: function () {
          return this.perform("render");
        },
      }
    );

    return () => App.cable.subscriptions.remove(subscription);
  });
</script>

<style>
  .alert-entry {
    word-break: break-all;
    color: #bbb;
  }
  .alert-type {
    color: #e5c07b;
  }
  .alert-pipeline {
    color: #c678dd;
  }
  .alert-state {
    color: #98c379;
  }
  .alert-message {
    color: #e06c75;
  }
  .alert-date {
    color: #56b6c2;
  }
</style>

<Log let:entry entries={alerts}>
  <div class="alert-entry">
    <span class="alert-date" title="Time">
      {format(entry.event_time)}
    </span>
    ▶
    <span class="alert-pipeline" title="Pipeline">({entry.pipeline})</span>
    <span class="alert-state" title="State">[{entry.alert_state}]</span>
    <span class="alert-type" title="Alert type">{entry.alert_type}:</span>
    <span class="alert-message" title="Message">{entry.message}</span>
  </div>
</Log>
